import { FilterService } from '@/services/filter.service.js'

export const Vacancies = axios => ({
  list(filters = {}) {
    const params = { ...filters }
    const filterService = FilterService()

    params.industries = params?.industries?.map(_ => _.slug)
    params.consultants = params?.consultants?.map(_ => _.slug)
    params.recruiters = params?.recruiters?.map(_ => _.slug)
    params.management_consultants = params?.management_consultants?.map(_ => _.slug)
    params.categories = params?.categories?.map(_ => _.slug)
    params.companies = params?.companies?.map(_ => _.slug)
    params.business_units = params?.business_units?.map(_ => _.slug)
    params.orders = params?.orders?.map(_ => _.slug)
    params.statuses = params?.statuses?.map(_ => _.slug)
    params.titles = params?.titles?.map(_ => _.slug)
    params.keywords = params?.keywords?.map(_ => _.slug)
    params.skills = params?.skills?.map(_ => _.slug)
    params.experience_levels = params?.experience_levels?.map(_ => _.slug)
    params.employments = params?.employments?.map(_ => _.slug)
    params.degrees = params?.degrees?.map(_ => _.slug)
    params.languages = params?.languages?.map(_ => _.slug + ':' + _.level.id)
    params.remote_work_types = params?.remote_work_types?.map(_ => _.slug)
    params.spoc = params?.spoc?.slug
    params.job_model = params.job_model?.slug
    params.career_position = params?.career_position?.slug
    params.leading_experience = params?.leading_experience?.slug
    params.submit_method = params?.submit_method?.slug
    params.reserved = params?.reserved?.slug
    params.location = params?.location?.slug
    params.markets = params?.markets?.map(_ => _.slug)
    params.workload = params?.workload?.map(Number)
    params.filters = filterService.prepareAdvancedFilter(params.filters)

    return axios.get('/v1/vacancies', { params })
  },
  // TODO: Merge with simple list() after implementing "Bookmark" feature
  postList(filters = {}) {
    const params = { ...filters }
    const filterService = FilterService()

    params.industries = params?.industries?.map(_ => _.slug)
    params.consultants = params?.consultants?.map(_ => _.slug)
    params.recruiters = params?.recruiters?.map(_ => _.slug)
    params.management_consultants = params?.management_consultants?.map(_ => _.slug)
    params.categories = params?.categories?.map(_ => _.slug)
    params.companies = params?.companies?.map(_ => _.slug)
    params.business_units = params?.business_units?.map(_ => _.slug)
    params.orders = params?.orders?.map(_ => _.slug)
    params.statuses = params?.statuses?.map(_ => _.slug)
    params.titles = params?.titles?.map(_ => _.slug)
    params.keywords = params?.keywords?.map(_ => _.slug)
    params.skills = params?.skills?.map(_ => _.slug)
    params.experience_levels = params?.experience_levels?.map(_ => _.slug)
    params.employments = params?.employments?.map(_ => _.slug)
    params.degrees = params?.degrees?.map(_ => _.slug)
    params.languages = params?.languages?.map(_ => _.slug + ':' + _.level.id)
    params.remote_work_types = params?.remote_work_types?.map(_ => _.slug)
    params.spoc = params?.spoc?.slug
    params.job_model = params.job_model?.slug
    params.career_position = params?.career_position?.slug
    params.leading_experience = params?.leading_experience?.slug
    params.submit_method = params?.submit_method?.slug
    params.reserved = params?.reserved?.slug
    params.location = params?.location?.slug
    params.markets = params?.markets?.map(_ => _.slug)
    params.workload = params?.workload?.map(Number)
    params.filters = filterService.prepareAdvancedFilter(params.filters)

    return axios.post('/v1/vacancies/full-list', params)
  },

  shortList(filters = {}) {
    const params = { ...filters }

    params.companies = params?.companies?.map(_ => _.slug)
    params.orders = params?.orders?.map(_ => _.slug)

    return axios.get('/v1/vacancies/list', { params })
  },

  create(payload) {
    return axios.post('/v1/vacancies', payload)
  },

  update(slug, payload) {
    return axios.put(`/v1/vacancies/${slug}`, payload)
  },

  changeStatus(slug, status, note = null) {
    return axios.put(`/v1/vacancies/${slug}/status`, { note, status })
  },

  get: {
    payload(slug) {
      return axios.get(`/v1/vacancies/${slug}/payload`)
    },
    index(slug) {
      return axios.get(`/v1/vacancies/${slug}`)
    }
  },

  makePublication(slug) {
    return axios.post(`/v1/vacancies/${slug}/publication`)
  },

  clone(slug) {
    return axios.post(`/v1/vacancies/${slug}/clone`)
  },

  view: {
    collapse(slug) {
      return axios.get(`/v1/vacancies/${slug}/view/collapse`)
    },
    head(slug) {
      return axios.get(`/v1/vacancies/${slug}/view/head`)
    },
    detail(slug) {
      return axios.get(`/v1/vacancies/${slug}/view/detail`)
    },
    activities(slug) {
      return axios.get(`/v1/vacancies/${slug}/activities`)
    }
  },

  notes: {
    get(slug) {
      return axios.get(`/v1/vacancies/${slug}/notes`)
    },
    create(slug, note) {
      return axios.post(`/v1/vacancies/${slug}/notes`, note)
    },
    pin(slug, note) {
      return axios.put(`/v1/vacancies/${slug}/notes/${note}/pin`)
    }
  },

  post(payload) {
    return axios.post('/v1/vacancies', payload)
  },

  delete(slug) {
    return axios.delete(`/v1/vacancies/${slug}`)
  },

  getSimilar(slug, page = 1, perPage = 10, filters = {}) {
    return axios.get(`/v1/vacancies/${slug}/similar`, { params: { page, per_page: perPage, ...filters } })
  },

  getPublications(slug, filters = {}, page = 1, perPage = 1000) {
    return axios.get(`/v1/vacancies/${slug}/publications`, { params: { page, per_page: perPage, ...filters } })
  },

  getProcesses(slug, filters = {}, page = 1, perPage = 1000) {
    return axios.get(`/v1/vacancies/${slug}/processes`, { params: { page, per_page: perPage, ...filters } })
  },

  findKeywords(search) {
    return axios.get('/v1/vacancies/keywords/search', { params: { search } })
  },
  preview: {
    get(slug, processSlug) {
      if (processSlug) {
        return axios.get(`/v1/vacancies/${slug}/preview/${processSlug}`)
      }

      return axios.get(`/v1/vacancies/${slug}/preview`)
    },
    getCompany(slug, processSlug) {
      if (processSlug) {
        return axios.get(`/v1/vacancies/${slug}/company/preview/${processSlug}`)
      }

      return axios.get(`/v1/vacancies/${slug}/company/preview`)
    }
  },

  aggregates: {
    activeCount(filters) {
      const params = { ...filters }

      params.categories = params?.categories?.map(_ => _.slug)
      params.locations = params?.locations?.map(_ => _.slug)

      return axios.get('/v1/vacancies/aggregates/active-count', { params })
    }
  }

})
